var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useEndSingleRoomMutation } from '../../../../store/services/breakoutRoomApi';
import { EndBreakoutRoomReq } from '../../../../helpers/proto/plugnmeet_breakout_room_pb';
const EndBtn = ({ breakoutRoomId }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const [endSingleRoom, { isLoading, data }] = useEndSingleRoomMutation();
    const [disable, setDisable] = useState(false);
    useEffect(() => {
        setDisable(!!isLoading);
    }, [isLoading]);
    useEffect(() => {
        if (data) {
            if (data.status) {
                toast(t('breakout-room.room-ended'), {
                    type: 'info',
                });
            }
            else {
                toast(t(data.msg), {
                    type: 'error',
                });
            }
        }
    }, [data]);
    const endRoom = () => {
        endSingleRoom(new EndBreakoutRoomReq({ breakoutRoomId }));
    };
    return (_jsx("div", { className: "end-room-btn", children: _jsx("button", { className: "text-center py-1 px-3 mt-1 text-xs transition ease-in bg-brandRed hover:bg-brandRed/90 text-white font-semibold rounded-lg", onClick: endRoom, disabled: disable, children: t('breakout-room.end-room') }) }));
};
_react_refresh_temp_1 = EndBtn;
$RefreshReg$(_react_refresh_temp_1, "EndBtn");
_react_refresh_temp_2(EndBtn, "vkWoiTbw8lhhVvxvBg3swOS8JM0=", false, () => [useTranslation, useEndSingleRoomMutation]);
export default EndBtn;
